'use client'

import { Badge, Card, Cell, Image, Spacer, Text } from '@vinted/web-ui'
import { ReactNode } from 'react'

import { useAsset } from '@marketplace-web/shared/assets'

import { VasImages } from '../../../constants/vas-entry-point'

type Props = {
  title: ReactNode
  subtitle: ReactNode
  badgeTitle?: ReactNode
  badgeSubtitle?: ReactNode
  icon?: VasImages
  onClick: () => void
  testId?: string
}

const VasBanner = ({
  title,
  subtitle,
  icon,
  onClick,
  testId,
  badgeTitle,
  badgeSubtitle,
}: Props) => {
  const asset = useAsset('/assets/profile-banners')

  const getIconElement = () => {
    if (!icon) {
      return null
    }

    return (
      <Image
        src={asset(`${icon}.svg`, { theme: { dark: `${icon}-dark.svg` } })}
        size={Image.Size.XLarge}
        testId={icon}
      />
    )
  }

  const renderDiscountBadge = () => {
    if (!badgeTitle) return null

    return (
      <>
        <Spacer size={Spacer.Size.Medium} />
        <Cell
          styling={Cell.Styling.Tight}
          theme="transparent"
          prefix={<Badge content={badgeTitle} theme="primary" />}
          body={badgeSubtitle && <Text as="span" type={Text.Type.Caption} text={badgeSubtitle} />}
        />
      </>
    )
  }

  return (
    <div className="u-fill-width u-fill-child-component">
      <Card>
        <div className="u-overflow-hidden u-fill-height u-fill-child-component u-background-extra-light">
          <Cell type={Cell.Type.Navigating} theme="transparent" testId={testId} onClick={onClick}>
            <Cell
              title={title}
              prefix={getIconElement()}
              theme="transparent"
              styling={Cell.Styling.Tight}
            >
              <Text as="span" text={subtitle} type={Text.Type.Subtitle} html />
              {renderDiscountBadge()}
            </Cell>
          </Cell>
        </div>
      </Card>
    </div>
  )
}

export default VasBanner
